/**
 * Alert Store Slice (Phase 3 — Step 3.7).
 */

import type { StateCreator } from 'zustand';
import type { Alert } from '@/notifications/alertEngine';

export interface AlertSlice {
  alerts: Alert[];

  addAlerts: (alerts: Alert[]) => void;
  dismissAlert: (id: string) => void;
  clearAlerts: () => void;
  clearAlertsByCourse: (courseId: string) => void;
}

export const createAlertSlice: StateCreator<AlertSlice> = (set) => ({
  alerts: [],

  addAlerts: (newAlerts) => {
    set((state) => {
      // Deduplicate: don't add alerts with the same type + courseId + message
      const existing = new Set(state.alerts.map((a) => `${a.type}:${a.courseId}:${a.message}`));
      const unique = newAlerts.filter(
        (a) => !existing.has(`${a.type}:${a.courseId}:${a.message}`),
      );
      return { alerts: [...state.alerts, ...unique] };
    });
  },

  dismissAlert: (id) => {
    set((state) => ({
      alerts: state.alerts.filter((a) => a.id !== id),
    }));
  },

  clearAlerts: () => {
    set({ alerts: [] });
  },

  clearAlertsByCourse: (courseId) => {
    set((state) => ({
      alerts: state.alerts.filter((a) => a.courseId !== courseId),
    }));
  },
});
